module.exports = __webpack_public_path__ + "img/introduce3.e2f4515a.png";